import Cropper from 'cropperjs';
import compress from './imageCompressor';

let cropper;

const hideModal = () => {
  const modal = document.getElementById('cropper-modal');
  modal.classList.remove('modal--open');
  modal.classList.add('modal--closed');
};

const discardImage = () => {
  hideModal();
};

const showModal = (event) => {
  // this shows the modal and load the images to be cropped
  if (event.target.files[0].type === 'image/svg+xml') return;
  const inputId = event.target.id;
  const imgData = event.target.files[0];
  const inputElement = document.getElementById('input-origin');
  inputElement.value = inputId;
  const modal = document.getElementById('cropper-modal');
  modal.classList.remove('modal--closed');
  modal.classList.add('modal--open');

  if (inputId === 'enterprise_admin_composite_company_microsite_hero_image') {
    cropper.setAspectRatio(2.26 / 1);
    cropper.options.cropBoxResizable = false;
    cropper.options.toggleDragModeOnDblclick = false;
    cropper.options.dragMode = 'none';
  } else if (inputId === 'enterprise_admin_composite_company_microsite_hero_image_mobile') {
    cropper.setAspectRatio(1.11 / 1);
    cropper.options.cropBoxResizable = false;
    cropper.options.toggleDragModeOnDblclick = false;
    cropper.options.dragMode = 'none';
  } else if (inputId === 'enterprise_admin_composite_company_microsite_logo') {
    cropper.setAspectRatio(NaN);
    cropper.options.cropBoxResizable = true;
    cropper.options.toggleDragModeOnDblclick = true;
    cropper.options.dragMode = 'crop';
  }
  cropper.replace(URL.createObjectURL(imgData));
};

const crop = () => {
  const origin = document.getElementById('input-origin');
  const inputElement = document.getElementById(origin.value);
  const imgData = inputElement.files[0];
  cropper.getCroppedCanvas().toBlob((blob) => {
    // Make a new cropped image file using that blob object
    const file = new File([blob], imgData.name,
      { type: imgData.type, lastModified: new Date().getTime() },
    );

    const container = new DataTransfer();
    container.items.add(file);
    // Replace the original image file with the new cropped image file
    inputElement.files = container.files;
    hideModal();
    compress(inputElement, inputElement.files[0], inputElement.dataset.maxSizeValue);
  }, imgData.type);
};

export default () => {
  const imageModal = document.getElementById('image-modal');
  if (!imageModal) return;

  cropper = new Cropper(imageModal, {
    autoCropArea: 1,
    viewMode: 1,
    scalable: false,
    zoomable: false,
    movable: false,
    minCropBoxWidth: 200,
    minCropBoxHeight: 200,
  });

  // Attach event listeners
  const cropButton = document.getElementById('crop-image-button');
  cropButton.addEventListener('click', crop);

  const closeButtons = document.querySelectorAll('[data-modal-close-button]');
  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', discardImage);
  });

  const fileInputs = document.querySelectorAll('.js-eep-input-file');
  fileInputs.forEach((fileInput) => {
    fileInput.addEventListener('change', showModal);
  });
};
